import * as React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/utils';

const Checkbox = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, checked, ...props }, ref) => (
  <div className="relative inline-flex items-center">
    <input
      ref={ref}
      type="checkbox"
      checked={checked}
      className={cn(
        'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none',
        className
      )}
      {...props}
    />
    <div className={cn(
      'absolute left-0 top-0 h-4 w-4 flex items-center justify-center text-primary-foreground pointer-events-none',
      checked ? 'bg-primary' : 'opacity-0'
    )}>
      <Check className="h-4 w-4" />
    </div>
  </div>
));
Checkbox.displayName = 'Checkbox';

export { Checkbox };